let debugInfo;

export const getAPIRoot = () => process.env.GATSBY_API_ROOT;

export const getDebugInfo = async () => {
  const apiRoot = await getAPIRoot();
  if (!debugInfo) {
    try {
      debugInfo = await (await fetch(`${apiRoot}/api/version`)).json();
    } catch (err) {
      debugInfo = { error: 'Unable to load debug info' };
    }
  }

  return debugInfo;
};

export const refreshData = () => {
  fetch('/__refresh', { method: 'POST' });
};

export const getContactFormFetchOptions = (data) => ({
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(data),
  withoutLocale: true,
});
